module.exports = __webpack_public_path__ + "img/item16.da091fa1.png";